import { SelfURIMap } from './appTypings';

export const selfUri: SelfURIMap = {
  elisa: 'https://elisa-areena.dev.yle.fi',
  hbbtv: 'https://hbbtv-areena.dev.yle.fi',
  philips: 'https://philips-areena.dev.yle.fi',
  panasonic: 'https://panasonic-areena.dev.yle.fi',
  vestel: 'https://vestel-areena.dev.yle.fi',
  hisense: 'https://hisense-areena.dev.yle.fi',
  tivo: 'https://tivo-areena.dev.yle.fi',
  ps4: 'https://playstation4-areena.dev.yle.fi',
  ps5: 'https://playstation5-areena.dev.yle.fi',
  telia: 'https://telia-areena.dev.yle.fi',
  tizen: 'https://samsung-areena.dev.yle.fi',
  webos: 'https://lg-areena.dev.yle.fi',
};
